import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";

export const getValuesWithCurrentSearchFieldState = (
    formValues: PropertyConfiguratorSearchFormValuesType,
    name?: string,
    value?: unknown
): PropertyConfiguratorSearchFormValuesType => {
    return {
        ...formValues,
        ...(name === "search" && {search: value}),
        ...(name === "price" && {price: value}),
        ...(name === "construction_end_date" && {construction_end_date: value})
    };
};
import {PropertyConfiguratorSearchFormValuesType} from "../types/PropertyConfiguratorSearchFormValuesType";

export const getValuesWithCurrentSearchFieldState = (
    formValues: PropertyConfiguratorSearchFormValuesType,
    name?: string,
    value?: unknown
): PropertyConfiguratorSearchFormValuesType => {
    return {
        ...formValues,
        ...(name === "search" && {search: value}),
        ...(name === "price" && {price: value}),
        ...(name === "construction_end_date" && {construction_end_date: value})
    };
};
